import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getUniqueKey, isMobile } from '../../utils/HTMLutils';
import Tooltip from '../tooltip/Tooltip';
import './TooltipManager.scss';
const rootClassName = 'tooltip-manager';

export default function TooltipManager() {
  const [arrayOfTooltips, setArrayOfTooltips] = useState<any[]>([]);
  const tooltips = useRef(arrayOfTooltips);
  tooltips.current = arrayOfTooltips;

  const [intervalId, setIntervalId] = useState<any>(null);
  const intervalIdRef = useRef(intervalId);
  intervalIdRef.current = intervalId;

  useEffect(() => {
    if (intervalIdRef.current) clearInterval(intervalIdRef.current);

    const enter = (evt: any) => {
      const id = evt.target.getAttribute('tooltip-id')
        ? evt.target.getAttribute('tooltip-id')
        : `tooltip${getUniqueKey()}`;
      if (!evt.target.getAttribute('tooltip-id')) {
        evt.target.setAttribute('tooltip-id', id);
      }
      const position = evt.target.getAttribute('tooltip-position')
        ? evt.target.getAttribute('tooltip-position')
        : TooltipPosition.Top;
      const text = String(evt.target.getAttribute('tooltip-text'));
      if (!text) return;
      const bounding = evt.target.getBoundingClientRect();
      const elementX = bounding.x;
      const elementY = bounding.y;
      const elementWidth = bounding.width;
      const elementHeight = bounding.height;
      const style: any = {};
      if (position === TooltipPosition.Top) {
        style.left = `${parseInt(elementX) + parseInt(elementWidth) / 2}px`;
        style.top = `${parseInt(elementY)}px`;
        style.transform = 'translate(-50%, calc(-100% - 11px))';
      } else if (position === TooltipPosition.Bottom) {
        style.left = `${parseInt(elementX) + parseInt(elementWidth) / 2}px`;
        style.top = `${parseInt(elementY) + parseInt(elementHeight)}px`;
        style.transform = 'translate(-50%, 4px)';
      } else if (position === TooltipPosition.Left) {
        style.left = `${parseInt(elementX) - 4}px`;
        style.top = `${parseInt(elementY) + parseInt(elementHeight) / 2}px`;
        style.transform = 'translate(calc(-100% - 7px), -50%)';
      } else {
        // Right
        style.left = `${parseInt(elementX) + parseInt(elementWidth)}px`;
        style.top = `${parseInt(elementY) + parseInt(elementHeight) / 2}px`;
        style.transform = 'translate(4px, -50%)';
      }

      const arr = tooltips.current.slice();
      arr.push({
        id,
        text,
        position,
        style
      });
      setArrayOfTooltips(arr);
    };
    const leave = (evt: any) => {
      const id = evt.target.getAttribute('tooltip-id');
      let arr = tooltips.current.slice();
      arr = arr.filter((t) => t.id !== id);
      setArrayOfTooltips(arr);
    };

    if (!isMobile()) {
      setIntervalId(
        setInterval(() => {
          document.querySelectorAll('[tooltip-text]').forEach((el) => {
            if (!el.hasAttribute('tooltip-id')) {
              el.addEventListener('mouseenter', enter);
              el.addEventListener('mouseleave', leave);
            }
          });
          document.querySelectorAll('.component-tooltip').forEach((el) => {
            const id = el.getAttribute('id');
            if (!document.querySelector(`[tooltip-id=${id}]`)) {
              let arr = tooltips.current.slice();
              arr = arr.filter((t) => t.id !== id);
              setArrayOfTooltips(arr);
            }
          });
        }, 100)
      );
    }

    return () => {
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
    };
  }, []);

  return (
    <React.Fragment>
      <TransitionGroup className={rootClassName}>
        {arrayOfTooltips.map((tooltip) => {
          return (
            <CSSTransition
              timeout={300}
              classNames={`${rootClassName}-tooltip`}
              key={tooltip.id}
              unmountOnExit
            >
              <Tooltip
                id={tooltip.id}
                position={tooltip.position}
                className={`${rootClassName}-tooltip`}
                style={{ ...tooltip.style }}
                onMouseLeave={() => {
                  if (
                    !document.querySelectorAll(`[tooltip-id=${tooltip.id}]`)
                      .length
                  ) {
                    let arr = tooltips.current.slice();
                    arr = arr.filter((t) => t.id !== tooltip.id);
                    setArrayOfTooltips(arr);
                  }
                }}
              >
                {tooltip.text}
              </Tooltip>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </React.Fragment>
  );
}

TooltipManager.propTypes = {};

TooltipManager.defaultProps = {};
